import Api from "@/services/Index";

const getByType = async (type) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/document-constants/type/${encodeURIComponent(type)}`);
};

const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/document-constants", data);
};

const update = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/document-constants/${id}`, data);
};

const remove = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete(`/document-constants/${id}`);
};

const updateRanks = async (type, ids) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/document-constants/type/${encodeURIComponent(type)}/rank`, { ids });
};

export default {
    getByType,
    store,
    update,
    remove,
    updateRanks
};
